export default {
    init() {
        this.showBody();
    },
    showBody() {
        $('body').on('click', '#articles_table .show_body', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/admin/show_article_body',
                data: ({
                    id: $(this).data('article_id'),
                }),
                success: function (response) {
                    $('#modal_info').html(response);
                    $('#article_modal').modal('show');
                },
            });
        });
    }
}
